<script setup lang="ts">
import { PropType } from "vue";
import { FraudChecker } from "~/types/fraudChecker";
import { useCustomerProfileStore } from "~/stores/customerProfileStore";
const profileStore = useCustomerProfileStore();
const props = defineProps({
  remoteUse: {
    type: Boolean,
    required: false,
    default: false,
  },
  remoteTableData: {
    type: Object as PropType<FraudChecker | null>,
    default: () => null,
    required: false,
  },
});
</script>

<template>
  <TableContainer
    :loading="profileStore.fraudCheckerTableLoading"
    :size="props.remoteUse ? 'small' : ''"
    :table-data="[props.remoteTableData].filter(Boolean)"
  >
    <el-table-column
      label="Total Parcels"
      prop="total_parcels"
      sortable="custom"
      min-width="160"
    />
    <el-table-column
      label="Total Delivered"
      prop="total_delivered"
      sortable="custom"
      min-width="160"
    />
    <el-table-column
      label="Total Cancelled"
      prop="total_cancelled"
      sortable="custom"
      min-width="160"
    />
    <el-table-column
      label="Success Percentage"
      prop="success_percentage"
      sortable="custom"
      min-width="160"
    >
      <template #default="scope">
        {{ scope.row.success_percentage }}%
      </template>
    </el-table-column>
  </TableContainer>
</template>
